document.addEventListener("DOMContentLoaded", function() {
  console.log("✅ Baby Names script loaded");

  const alphabetFilter = document.getElementById("alphabetFilter");
  const nameGrid = document.getElementById("nameGrid");
  const searchInput = document.getElementById("searchInput");
  const loadMoreBtn = document.getElementById("loadMoreBtn");
  const heartBtn = document.getElementById("heartBtn");
  const emailModal = document.getElementById("emailModal");
  const likedNamesList = document.getElementById("likedNamesList");

  if (!alphabetFilter || !nameGrid) {
    console.error("❌ Missing required HTML elements. Check IDs in your HTML.");
    return;
  }

  let allNames = [];
  let displayedCount = 0;
  const batchSize = 50;
  let currentFilter = "";
  let currentGender = "All";
  let likedNames = [];

  // Generate A-Z Buttons
  "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").forEach(letter => {
    const btn = document.createElement("button");
    btn.textContent = letter;
    btn.addEventListener("click", () => {
      currentFilter = letter;
      displayedCount = 0;
      renderNames();
      document.querySelectorAll(".filter-bar button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
    });
    alphabetFilter.appendChild(btn);
  });

  // Fetch JSON Data
  fetch("https://cdn.shopify.com/s/files/1/0921/8290/5125/files/baby_names_updated_with_W.json?v=1754399310")
    .then(res => res.json())
    .then(data => {
      allNames = [];
      for (const letter in data) {
        data[letter].forEach(n => {
          allNames.push({
            Alphabet: letter,
            Name: n.name,
            BoyGirl: n.gender,
            Meaning: n.meaning
          });
        });
      }
      console.log("✅ Loaded names:", allNames.length);
      renderNames();
    })
    .catch(err => {
      console.error("❌ JSON fetch error:", err);
    });

  function renderNames() {
    nameGrid.innerHTML = "";
    let filtered = allNames.filter(n => {
      const byAlphabet = currentFilter ? n.Alphabet === currentFilter : true;
      const byGender = currentGender === "All" || n.BoyGirl === currentGender;
      const bySearch = searchInput.value ?
        (n.Name.toLowerCase().includes(searchInput.value.toLowerCase()) ||
         n.Meaning.toLowerCase().includes(searchInput.value.toLowerCase())) : true;
      return byAlphabet && byGender && bySearch;
    });

    let toShow = filtered.slice(0, displayedCount + batchSize);
    toShow.forEach(n => {
      const card = document.createElement("div");
      card.className = "name-card";
      card.innerHTML = `<h5>${n.Name}</h5><p>${n.BoyGirl}</p><p>${n.Meaning}</p>
                        <span class="heart">♡</span>`;
      const heartIcon = card.querySelector(".heart");
      heartIcon.addEventListener("click", () => {
        if (likedNames.includes(n.Name)) {
          likedNames = likedNames.filter(x => x !== n.Name);
          heartIcon.classList.remove("liked");
          heartIcon.textContent = "♡";
        } else {
          likedNames.push(n.Name);
          heartIcon.classList.add("liked");
          heartIcon.textContent = "❤️";
        }
        if (likedNamesList) {
          likedNamesList.value = likedNames.join(", ");
        }
      });
      nameGrid.appendChild(card);
    });

    displayedCount += batchSize;
    loadMoreBtn.style.display = (displayedCount < filtered.length) ? "block" : "none";
  }

  // Search
  searchInput.addEventListener("input", () => {
    displayedCount = 0;
    renderNames();
  });

  // Gender Filter
  document.querySelectorAll(".gender-filter button").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".gender-filter button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      currentGender = btn.textContent;
      displayedCount = 0;
      renderNames();
    });
  });

  // Load More
  loadMoreBtn.addEventListener("click", () => renderNames());

  // Heart Modal
  heartBtn.addEventListener("click", () => {
    emailModal.style.display = "block";
    likedNamesList.value = likedNames.join(", ");
  });
  emailModal.addEventListener("click", (e) => {
    if (e.target === emailModal) emailModal.style.display = "none";
  });
});
